import { isEqual, isNumber, isFunction } from '@antv/util';
import * as d3Timer from 'd3-timer';
import * as d3Ease from 'd3-ease';
import { interpolate, interpolateArray } from 'd3-interpolate'; // ç®åæ´ä½å¨ç»åªéè¦æ°å¼åæ°ç»çå·®å¼è®¡ç®
import * as PathUtil from '../util/path';
import { isColorProp, isGradientColor } from '../util/color';
var IDENTITY_MATRIX = [1, 0, 0, 0, 1, 0, 0, 0, 1];
/**
 * ä½¿ç¨ ratio è¿è¡æå¼è®¡ç®æ¥æ´æ°å±æ§
 * @param {IElement}  shape    åç´ 
 * @param {Animation} animation å¨ç»
 * @param {number}    ratio    æ¯ä¾
 * @return {boolean}  å¨ç»æ¯å¦æ§è¡å®æ
 */
function _update(shape, animation, ratio) {
    var cProps = {}; // æ­¤å»å±æ§
    var fromAttrs = animation.fromAttrs, toAttrs = animation.toAttrs;
    if (shape.destroyed) {
        return;
    }
    var interf; //  å·®å¼å½æ°
    for (var k in toAttrs) {
        if (!isEqual(fromAttrs[k], toAttrs[k])) {
            if (k === 'path') {
                var toPath = toAttrs[k];
                var fromPath = fromAttrs[k];
                if (toPath.length > fromPath.length) {
                    toPath = PathUtil.parsePathString(toAttrs[k]); // ç»ç¹ç¶æ
                    fromPath = PathUtil.parsePathString(fromAttrs[k]); // èµ·å§ç¶æ
                    fromPath = PathUtil.fillPathByDiff(fromPath, toPath);
                    fromPath = PathUtil.formatPath(fromPath, toPath);
                    animation.fromAttrs.path = fromPath;
                    animation.toAttrs.path = toPath;
                }
                else if (!animation.pathFormatted) {
                    toPath = PathUtil.parsePathString(toAttrs[k]);
                    fromPath = PathUtil.parsePathString(fromAttrs[k]);
                    fromPath = PathUtil.formatPath(fromPath, toPath);
                    animation.fromAttrs.path = fromPath;
                    animation.toAttrs.path = toPath;
                    animation.pathFormatted = true;
                }
                cProps[k] = [];
                for (var i = 0; i < toPath.length; i++) {
                    var toPathPoint = toPath[i];
                    var fromPathPoint = fromPath[i];
                    var cPathPoint = [];
                    for (var j = 0; j < toPathPoint.length; j++) {
                        if (isNumber(toPathPoint[j]) && fromPathPoint && isNumber(fromPathPoint[j])) {
                            interf = interpolate(fromPathPoint[j], toPathPoint[j]);
                            cPathPoint.push(interf(ratio));
                        }
                        else {
                            cPathPoint.push(toPathPoint[j]);
                        }
                    }
                    cProps[k].push(cPathPoint);
                }
            }
            else if (k === 'matrix') {
                /*
                 å¯¹ç©éµè¿è¡æå¼æ¶ï¼éè¦ä¿è¯ç©éµä¸ä¸ºç©ºï¼ä¸ºç©ºåä½¿ç¨åä½ç©éµ
                 TODO: äºç»´åä¸ç»´åºæ¯ä¸åä½ç©éµä¸åï¼ä¹å WebGL çéè¦åè¿ä¸æ­¥å¤ç
                 */
                var matrixFn = interpolateArray(fromAttrs[k] || IDENTITY_MATRIX, toAttrs[k] || IDENTITY_MATRIX);
                var currentMatrix = matrixFn(ratio);
                cProps[k] = currentMatrix;
            }
            else if (isColorProp(k) && isGradientColor(toAttrs[k])) {
                cProps[k] = toAttrs[k];
            }
            else if (!isFunction(toAttrs[k])) {
                // éå½æ°ç±»åçå¼æè½åæå¼
                interf = interpolate(fromAttrs[k], toAttrs[k]);
                cProps[k] = interf(ratio);
            }
        }
    }
    shape.attr(cProps);
}
/**
 * æ ¹æ®èªå®ä¹å¸§å¨ç»å½æ° onFrame æ¥æ´æ°å±æ§
 * @param {IElement}  shape    åç´ 
 * @param {Animation} animation å¨ç»
 * @param {number}    elapsed  å¨ç»æ§è¡æ¶é´(æ¯«ç§)
 * @return {boolean}  å¨ç»æ¯å¦æ§è¡å®æ
 */
function update(shape, animation, elapsed) {
    var startTime = animation.startTime, delay = animation.delay;
    // å¦æè¿æ²¡æå¼å§æ§è¡ææåï¼åä¸æ´æ°
    if (elapsed < startTime + delay || animation._paused) {
        return false;
    }
    var ratio;
    var duration = animation.duration;
    var easing = animation.easing;
    // å·²æ§è¡æ¶é´
    elapsed = elapsed - startTime - animation.delay;
    if (animation.repeat) {
        // å¦æå¨ç»éå¤æ§è¡ï¼å elapsed > durationï¼è®¡ç® ratio æ¶éåæ¨¡
        ratio = (elapsed % duration) / duration;
        ratio = d3Ease[easing](ratio);
    }
    else {
        ratio = elapsed / duration;
        if (ratio < 1) {
            // å¨ç»æªæ§è¡å®
            ratio = d3Ease[easing](ratio);
        }
        else {
            // å¨ç»å·²æ§è¡å®
            if (animation.onFrame) {
                shape.attr(animation.onFrame(1));
            }
            else {
                shape.attr(animation.toAttrs);
            }
            return true;
        }
    }
    if (animation.onFrame) {
        var attrs = animation.onFrame(ratio);
        shape.attr(attrs);
    }
    else {
        _update(shape, animation, ratio);
    }
    return false;
}
var Timeline = /** @class */ (function () {
    /**
     * æ¶é´è½´æé å½æ°ï¼ä¾èµäºç»å¸
     * @param {}
     */
    function Timeline(canvas) {
        /**
         * æ§è¡å¨ç»çåç´ åè¡¨
         * @type {IElement[]}
         */
        this.animators = [];
        /**
         * å½åæ¶é´
         * @type {number}
         */
        this.current = 0;
        /**
         * å®æ¶å¨
         * @type {d3Timer.Timer}
         */
        this.timer = null;
        this.canvas = canvas;
    }
    /**
     * åå§åå®æ¶å¨
     */
    Timeline.prototype.initTimer = function () {
        var _this = this;
        var isFinished = false;
        var shape;
        var animations;
        var animation;
        this.timer = d3Timer.timer(function (elapsed) {
            _this.current = elapsed;
            if (_this.animators.length > 0) {
                for (var i = _this.animators.length - 1; i >= 0; i--) {
                    shape = _this.animators[i];
                    if (shape.destroyed) {
                        // å¦æå·²ç»è¢«éæ¯ï¼ç´æ¥ç§»åºéå
                        _this.removeAnimator(i);
                        continue;
                    }
                    if (!shape.isAnimatePaused()) {
                        animations = shape.get('animations');
                        for (var j = animations.length - 1; j >= 0; j--) {
                            animation = animations[j];
                            isFinished = update(shape, animation, elapsed);
                            if (isFinished) {
                                animations.splice(j, 1);
                                isFinished = false;
                                if (animation.callback) {
                                    animation.callback();
                                }
                            }
                        }
                    }
                    if (animations.length === 0) {
                        _this.removeAnimator(i);
                    }
                }
                var autoDraw = _this.canvas.get('autoDraw');
                // éèªå¨æ¸²ææ¨¡å¼ä¸ï¼æå¨è°ç¨ canvas.draw() éæ°æ¸²æ
                if (!autoDraw) {
                    _this.canvas.draw();
                }
            }
        });
    };
    /**
     * å¢å å¨ç»åç´ 
     */
    Timeline.prototype.addAnimator = function (shape) {
        this.animators.push(shape);
    };
    /**
     * ç§»é¤å¨ç»åç´ 
     */
    Timeline.prototype.removeAnimator = function (index) {
        this.animators.splice(index, 1);
    };
    /**
     * æ¯å¦æå¨ç»å¨æ§è¡
     */
    Timeline.prototype.isAnimating = function () {
        return !!this.animators.length;
    };
    /**
     * åæ­¢å®æ¶å¨
     */
    Timeline.prototype.stop = function () {
        if (this.timer) {
            this.timer.stop();
        }
    };
    /**
     * åæ­¢æ¶é´è½´ä¸ææåç´ çå¨ç»ï¼å¹¶ç½®ç©ºå¨ç»åç´ åè¡¨
     * @param {boolean} toEnd æ¯å¦å°å¨ç»çæç»ç¶æï¼ç¨æ¥éä¼ ç»å¨ç»åç´ ç stopAnimate æ¹æ³
     */
    Timeline.prototype.stopAllAnimations = function (toEnd) {
        if (toEnd === void 0) { toEnd = true; }
        this.animators.forEach(function (animator) {
            animator.stopAnimate(toEnd);
        });
        this.animators = [];
        this.canvas.draw();
    };
    /**
     * è·åå½åæ¶é´
     */
    Timeline.prototype.getTime = function () {
        return this.current;
    };
    return Timeline;
}());
export default Timeline;
//# sourceMappingURL=timeline.js.map